import React from "react";


export function NotFoundPage() 
{   

    return(

        <div className="container-fluid" style={{backgroundColor: '#f5f5f5'}}>

          <div className="row justify-content-center align-items-center vh-100" >
            <div className="col-lg-10">
              <div className="d-flex flex-column justify-content-center align-items-center g-4 px-4 py-5 bg-white border rounded-2">
                <div className="d-flex flex-column align-items-center">
                  <img src='../favicon.png' alt='logo-ortega' style={{ maxHeight: '100px' }}/>
                  <span className="lead mb-1 text-green"> PANEL ORTEGA </span>
                </div>
                <span className="display-1 fw-bold text-green"> PAGE 404 </span>
              </div>
            </div>
          </div>

        </div>
    );
}